const features = [
  {
    icon: 'ri-4k-line',
    title: '4K蓝光画质',
    description: '支持4K HDR超高清画质，蓝光原盘品质，每一帧都细腻逼真，带来影院级视觉享受。'
  },
  {
    icon: 'ri-shield-check-line',
    title: '无广告纯净观影',
    description: '全程零广告干扰，不植入任何贴片、弹窗或中插广告，让观影回归纯粹体验。'
  },
  {
    icon: 'ri-speed-up-line',
    title: '流畅不缓冲',
    description: '全球CDN加速节点覆盖，智能码率自适应技术，无论何时何地都能流畅播放。'
  },
  {
    icon: 'ri-global-line',
    title: '海量资源库',
    description: '汇聚全球超过50000部影视资源，涵盖电影、电视剧、动漫、综艺等全品类内容。'
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端同步观看',
    description: '全面支持PC、手机、平板等多种设备，观影进度自动同步，随时随地接着看。'
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '7×24小时客服',
    description: '专业客服团队全天候在线，快速响应用户反馈，用心守护每一次观影体验。'
  }
];

export default function WhyChooseUs() {
  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="px-4 md:px-6 lg:px-8">
        <div className="max-w-[1440px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-lg md:text-2xl font-heading font-bold text-foreground-100 mb-2">
              为什么选择蘑菇影视
            </h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto">
              我们不断追求极致的观影体验，用技术和服务为每一位用户带来最好的影视享受
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {features.map((feature, index) => (
              <div
                key={index}
                className="flex gap-4 p-5 rounded-xl bg-background-50 border border-background-200/50 hover:border-primary-500/20 transition-all duration-300"
              >
                <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg bg-primary-500/10">
                  <i className={`${feature.icon} text-lg text-primary-500`}></i>
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-100 mb-1">
                    {feature.title}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}